module.exports = __webpack_public_path__ + "6ed256df3b2a917779e6cdf89804700c.pdf";